<div class="layout-variation-selector">
	<div class="label-default">{{ labelKey | translate }}</div>

	<mat-radio-group
		class="layout-variation-selector__options"
		[ngModel]="value"
		[disabled]="disabled"
		(ngModelChange)="onSelect($event)"
	>
		<div class="layout-variation-selector__item" *ngFor="let variation of options; trackBy: trackByValue">
			<mat-radio-button [value]="variation.value">
				{{ variation.labelKey | translate }}
			</mat-radio-button>
			<div class="layout-variation-selector__item__image" (click)="onSelect(variation.value)" role="button">
				<img
					[src]="getImageSrc(variation)"
					[alt]="variation.labelKey | translate"
					[class.selected]="value === variation.value"
				/>
			</div>
		</div>
	</mat-radio-group>
</div>
